import { render } from "./IconBanknote.vue?vue&type=template&id=6ce8ff5d"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBanknote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ce8ff5d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ce8ff5d', __exports__)) {
    api.reload('6ce8ff5d', __exports__)
  }
  
  module.hot.accept("./IconBanknote.vue?vue&type=template&id=6ce8ff5d", () => {
    api.rerender('6ce8ff5d', render)
  })

}


export default __exports__